// frontend/src/components/CourseBuilderForm.js
import React, { useState } from 'react';

const CourseBuilderForm = ({ onSave, onCancel }) => {
  const [courseData, setCourseData] = useState({
    title: '',
    description: '',
    category: 'development',
    level: 'beginner',
    price: 0,
    language: 'spanish'
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCourseData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const [thumbnail, setThumbnail] = useState(null);

  const handleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setThumbnail(e.target.files[0]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({
      ...courseData,
      thumbnail, // Agrega la imagen al objeto del curso
      status: 'draft',
      sections: [],
      goals: [],
      requirements: []
    });
  };
  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <h2 className="text-xl font-bold mb-4">Crear nuevo curso</h2>
      
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-gray-700 mb-2">Título del curso*</label>
          <input
            type="text"
            name="title"
            value={courseData.title}
            onChange={handleChange}
            className="w-full px-4 py-2 border rounded focus:ring-2 focus:ring-purple-600"
            required
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 mb-2">Imagen del curso</label>
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            className="w-full px-4 py-2 border rounded focus:ring-2 focus:ring-purple-600"
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 mb-2">Descripción*</label>
          <textarea
            name="description"
            value={courseData.description}
            onChange={handleChange}
            rows="4"
            className="w-full px-4 py-2 border rounded focus:ring-2 focus:ring-purple-600"
            required
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <div>
            <label className="block text-gray-700 mb-2">Categoría*</label>
            <select
              name="category"
              value={courseData.category}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded focus:ring-2 focus:ring-purple-600"
              required
            >
              <option value="development">Desarrollo</option>
              <option value="business">Negocios</option>
              <option value="design">Diseño</option>
              <option value="marketing">Marketing</option>
            </select>
          </div>

          <div>
            <label className="block text-gray-700 mb-2">Nivel*</label>
            <select
              name="level"
              value={courseData.level}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded focus:ring-2 focus:ring-purple-600"
              required
            >
              <option value="beginner">Principiante</option>
              <option value="intermediate">Intermedio</option>
              <option value="advanced">Avanzado</option>
            </select>
          </div>
        </div>

        <div className="mb-6">
          <label className="block text-gray-700 mb-2">Precio (USD)*</label>
          <input
            type="number"
            name="price"
            value={courseData.price}
            onChange={handleChange}
            min="0"
            step="0.01"
            className="w-full px-4 py-2 border rounded focus:ring-2 focus:ring-purple-600"
            required
          />
        </div>

        <div className="flex justify-end space-x-4">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-100"
          >
            Cancelar
          </button>
          <button
            type="submit"
            className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
          >
            Crear Curso
          </button>
        </div>
      </form>
    </div>
  );
};

export default CourseBuilderForm;